/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _sortBy from 'lodash.sortby';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import { task } from 'ember-concurrency';
import { isEmpty } from '@ember/utils';
import ReceiptModel from 'cio/models/receipt';
import AnalyticsService from 'cio/services/analytics';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';

interface BillingHistoryListArgs {
  receipts: ReceiptModel[];
}

export default class BillingHistoryList extends Component<BillingHistoryListArgs> {
  @service analytics!: AnalyticsService;
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;

  @computed('args.receipts.@each.invoicedAt')
  get mostRecentOverageReceipt() {
    let [receipt] = _sortBy(
      this.args.receipts.filter((receipt) => receipt.isOverages),
      ['invoicedAt'],
    ).reverse();
    return receipt;
  }

  @computed('args.receipts.@each.invoicedAt')
  get mostRecentPlanReceipt() {
    let [receipt] = _sortBy(
      this.args.receipts.filter((receipt) => receipt.isPlan),
      ['invoicedAt'],
    ).reverse();
    return receipt;
  }

  @computed('args.receipts.@each.invoicedAt')
  get mostRecentReceipt() {
    let [receipt] = _sortBy(this.args.receipts, ['invoicedAt']).reverse();
    return receipt;
  }

  @action
  didDownloadReceipt() {
    this.analytics.track('account', 'billing_receipt_download');
  }

  downloadInvoiceTask = task(async (invoiceId) => {
    try {
      let response = await this.api.request(`invoice/${invoiceId}`, { pathScope: 'account' });
      if (!isEmpty(response?.invoice?.invoice_pdf)) {
        this.analytics.track('account', 'billing_invoice_download');
        window.open(response?.invoice?.invoice_pdf, '_blank');
      }
    } catch (err) {
      this.apiErrors.report(err);
    }
  });
}
